import { render, staticRenderFns } from "./FaviconHeading.vue?vue&type=template&id=72f51a5e&"
import script from "./FaviconHeading.vue?vue&type=script&lang=js&"
export * from "./FaviconHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports